import * as internal from './nodeAccessor'
import * as external from './modelYamlAccessor'
import * as systemUtils from './utils/systemUtils'

export const adaptYamlNodeRoot = (root) => {
  adaptRootGlobalParameters(root);
  adaptRootFunctions(root);
};

export const adaptYamlNodeContainer = (container) => {
  adaptContainerParameters(container);
  adaptContainerChoices(container);
  adaptContainerConditions(container);
  adaptNodeLabel(container);
  adaptNodeComment(container);
  adaptParameterOutput(container);
  adaptParameterTarget(container);
  adaptChoiceValue(container);
};

export const adaptYamlNodeCondition = (node) => {
  return adaptKey(node, internal.getTagConditionExpressions(), external.getTagExpressions());
};

const adaptRootGlobalParameters = (root) => {
  return adaptKeyArray(root, internal.getTagParametersGlobal(), external.getTagGlobals());
};

const adaptRootFunctions = (root) => {
  return adaptKeyArray(root, internal.getTagFunctions(), external.getTagFunctions());
};

const adaptContainerParameters = (container) => {
  return adaptKeyArray(container, internal.getTagParameters(), external.getTagParameters());
};

const adaptContainerChoices = (container) => {
  return adaptKeyArray(container, internal.getTagChoices(), external.getTagChoices());
};

const adaptContainerConditions = (conditions) => {
  return adaptKeyArray(conditions, internal.getTagConditions(), external.getTagConditions());
};

const adaptChoiceValue = (choice) => {
  return adaptKey(choice, internal.getTagChoiceValue(), external.getTagChoiceValue());
};

const adaptParameterOutput = (parameter) => {
  return adaptKey(parameter, internal.getTagParameterOutput(), external.getTagParameterOutput());
};

const adaptParameterTarget = (parameter) => {
  return adaptKey(parameter, internal.getTagParameterTarget(), external.getTagParameterTarget());
};

const adaptNodeLabel = (node) => {
  return adaptKey(node, internal.getTagLabel(), external.getTagLabel());
};

const adaptNodeComment = (node) => {
  return adaptKey(node, internal.getTagComment(), external.getTagComment());
};

const adaptKey = (node, internal, external) => {
  if (external === internal) {
    return false;
  }

  const value = get(node, external);

  if (systemUtils.isNullish(value)) {
    return false;
  }

  systemUtils.changeKey(node, external, internal);

  return true;
};

const adaptKeyArray = (node, internal, external) => {
  if (external === internal) {
    return false;
  }

  const values = getRefArray(node, external);

  if (values.length === 0) {
    return false;
  }

  systemUtils.changeKey(node, external, internal);

  return true;
};

//------------------------------------------------------------------------

const get = (node, type, def = null) => {
  return node?.[type] ?? def;
};

const getRefArray = (node, type, def = []) => {
  const results = node?.[type];

  if (systemUtils.isArray(results)) {
    return [...results];
  }

  return def;
};